import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import { LastPage } from "@mui/icons-material";

export const getSocialMediaFeed = async (params) => {
  const urlSearchParams = new URLSearchParams({
    ...params,
    alunoid: _cookies.getItem("auth").user?.alunoid,
  }).toString();
  const res = await fetch(
    "https://middleware.cadernovirtual.com.br/Social.asmx/feedGeral?" +
      urlSearchParams,
    {
      headers: {
        "Content-Type": "application/json",
        token: _cookies.getItem("auth").token,
      },
    }
  );
  const data = await res.json();
  return data.d.result.map((foo) => ({ ...foo, currentPage: params.pagNum }));
};

export const useInfiniteSocialMediaFeed = ({
  config,
  themeId = 0,
  pageLength = 20,
  pageNumber = 1,
} = {}) => {
  const params = {
    temaid: themeId,
    pagNum: pageNumber,
    pagLength: pageLength,
  };
  return useInfiniteQuery({
    ...config,
    refetchOnWindowFocus: true,
    refetchInterval: 60 * 1000,
    queryKey: ["socialMediaFeed", { themeId }],
    queryFn: ({ pageParam = 1 }) =>
      getSocialMediaFeed({ ...params, pagNum: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      if (
        lastPage[0]?.currentPage == lastPage[0]?.total_paginas ||
        !lastPage[0]?.total_paginas
      ) {
        return undefined;
      }
      return lastPage[0].currentPage + 1;
    },
  });
};

// export const useGetSocialMediaFeed = ({
//   config,
//   themeId = 0,
//   pageLength = 100,
//   pageNumber = 1,
// } = {}) => {
//   const params = {
//     temaid: themeId,
//     pagNum: pageNumber,
//     pagLength: pageLength,
//   };
//   return useQuery({
//     ...config,
//     queryFn: () => getSocialMediaFeed(params),
//     queryKey: ["socialMediaFeed", params],
//   });
// };
